import { useMutation } from 'react-query';

import { customerSet as mutationFn } from 'api/endPoints/customerSet';

export const useMutationCustomerSet = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    id: number;
    name: string;
    description: string;
    opcHost: string;
    opcUsername: string;
    opcPassword: string;
    maxUsers: number;
    maxWbsLevel: number;
    confettiON: boolean;
    aiType: string;
}
